module.exports = __webpack_public_path__ + "img/SOL-empty-bkp.ae9434cc.svg";